/* Shared match filtering for the sports lists.
 *
 * The home page block and the Cricket / Football / Tennis pages each build
 * their own list from the same market feed, so the filter lives here rather
 * than being written four times and drifting.
 */

const DAY_MS = 24 * 60 * 60 * 1000;

const endOfToday = () => {
  const d = new Date();
  d.setHours(23, 59, 59, 999);
  return d.getTime();
};

/**
 * @param {object} item     one market from the feed
 * @param {string} timeFilter  "all" | "live" | "today" | "tomorrow"
 * @param {string} query    free text matched against runner and competition names
 */
export const matchesFilter = (item, timeFilter, query) => {
  const q = (query || "").trim().toLowerCase();
  if (q) {
    const haystack = (item?.runners || [])
      .map((r) => r?.runnerName || "")
      .concat([item?.competition?.name || ""])
      .join(" ")
      .toLowerCase();
    if (haystack.indexOf(q) === -1) return false;
  }

  const start = new Date(item?.event?.openDate).getTime();
  if (Number.isNaN(start)) return timeFilter === "all" || !timeFilter;

  const today = endOfToday();
  if (timeFilter === "live") return start <= Date.now();
  if (timeFilter === "today") return start <= today;
  if (timeFilter === "tomorrow") return start > today && start <= today + DAY_MS;
  return true;
};

export const TIME_FILTERS = [
  { key: "all", label: "All" },
  { key: "live", label: "Live" },
  { key: "today", label: "Today" },
  { key: "tomorrow", label: "Tomorrow" },
];

export default matchesFilter;
